module.exports = __webpack_public_path__ + "static/media/circle-close.9f705f7d.svg";